import {Component, OnInit} from '@angular/core';
import {NgxSpinnerService} from 'ngx-spinner';
import {CertificateService} from '../shared/services/certificate.service';
import {VerificationDtzFromCertificateDto} from '../shared/dto/verification-dtz-from-certificate.dto';
import {StorageService, StorageType} from 'gast-common-ng';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {VerificationDtzFormDto} from '../shared/dto/verification-dtz-form.dto';

@Component({
  selector: 'app-verification-dtz-pdf-form',
  templateUrl: './verification-dtz-pdf-form.component.html',
  styleUrls: ['./verification-dtz-pdf-form.component.css']
})
export class VerificationDtzPdfFormComponent implements OnInit {

  private subscription: Subscription = new Subscription();

  isLoading: boolean = false;
  isSubmitted: boolean = false;
  hasError: boolean = false;

  constructor(
    private spinnerService: NgxSpinnerService,
    private certificateService: CertificateService,
    private storageService: StorageService,
    private router: Router
  ) {
  }

  ngOnInit() {

    this.subscription = this.certificateService.resultDtzByUploadedPdfLoaded.subscribe((result: VerificationDtzFromCertificateDto) => {

      if (result) {

        this.storageService.setItem('VERIFICATION_FORM_PDF', VerificationDtzPdfFormComponent.mapQrCodeResponseDtoToFormDto(result),
          StorageType.Local);

        this.router.navigate(['verification-dtz-form'], {queryParams: {'from-pdf': true}})
          .then(() => window.scrollTo({top: 0}));
      }

      this.isLoading = false;
      this.spinnerService.hide();
    });

    this.subscription.add(this.certificateService.resultDtzByUploadedPdfError.subscribe((result: boolean) => {

      if (result !== undefined) {

        this.isLoading = false;
        this.hasError = result;
      }
    }));
  }

  uploadCertificate(event: any): void {

    const file = event.target.files[0];

    if (VerificationDtzPdfFormComponent.validFileExtension(file.name, ['pdf'])) {

      this.getCertificateDataFromPdf(file);
    }
  }

  backToDtzChoice(): void {

    this.router.navigate(['verification-dtz-choice']).then(() => window.scrollTo({top: 0}));
  }

  private static validFileExtension(name: string, allowedExtensions: Array<string>) {

    if (!name || name.length === 0 || name.split('.').length <= 1) {

      return false;
    }

    return allowedExtensions.includes(VerificationDtzPdfFormComponent.getFileExtension(name.toLocaleLowerCase()));
  }

  private static getFileExtension(name: string): string {

    const parts = name.split('.');

    return parts[parts.length - 1];
  }

  private getCertificateDataFromPdf(file: any) {

    const reader: FileReader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (fileString: any) => {

      this.spinnerService.show();
      this.isLoading = true;
      this.isSubmitted = true;

      this.certificateService.getCertificateDataFromPdf(fileString.target.result);
    };
  }

  private static mapQrCodeResponseDtoToFormDto(from: VerificationDtzFromCertificateDto): VerificationDtzFormDto {

    return {
      examDate: from.examDate,
      speakingScore: from.scoreSpeaking,
      dateOfBirth: from.dateOfBirth,
      writingScore: from.scoreWriting,
      maxWritingScore: from.maxWriting,
      fullName: from.fullName,
      listeningAndReadingLevel: `${from.gerLevelReadingAndListening} ${from.gerSublevelReadingAndListening}`,
      listeningAndReadingScore: from.scoreReadingAndListening,
      maxListeningAndReadingScore: from.maxReadingAndListening,
      maxSpeakingScore: from.maxSpeaking,
      overallResult: from.gerTotalLevel,
      participantNumber: from.participantNumber,
      speakingLevel: `${from.gerLevelSpeaking} ${from.gerSublevelSpeaking}`,
      writingLevel: `${from.gerLevelWriting} ${from.gerSublevelWriting}`,
    } as VerificationDtzFormDto;
  }
}
